const esLocale = 'es-ES';

export default {
  methods: {
    dateFormatter(dates) {
      function formatDate(dateIn) {
        const date = new Date(dateIn);
        const day = date.toLocaleString(esLocale, { day: '2-digit' });
        const month = date.toLocaleString(esLocale, { month: 'short' });
        const year = date.toLocaleString(esLocale, { year: 'numeric' });
        return `${day} ${month} ${year}`;
      }
      return `${formatDate(dates[0])} - ${formatDate(dates[1])}`;
    }
  }
};
